import React, { useContext } from "react";
import globalContext from "./globalContext";
import { Dots } from 'react-preloaders';
import Note from './Note';

const MyLoader = () => {
    const gContext = useContext(globalContext);
    if (gContext.loader.loading) {
        return (
            <Note
                title={
                    <div class="spinner">
                        <div class="bounce1"></div>
                        <div class="bounce2"></div>
                        <div class="bounce3"></div>
                    </div>
                }
                content={
                    <div class="spinner">
                        <div class="bounce1"></div>
                        <div class="bounce2"></div>
                        <div class="bounce3"></div>
                    </div>
                } />
        )
    } else {
        return "";
    }
}

export default MyLoader;